import { HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { HelpScope } from "@fysaro/shared";
import { useHelpDrawer } from "../hooks/useHelpDrawer";

interface HelpTriggerProps {
  scope?: HelpScope;
  articleId?: string | null;
}

export function HelpTrigger({ scope = "TENANT", articleId = null }: HelpTriggerProps) {
  const openHelp = useHelpDrawer((state) => state.openHelp);
  const { t } = useTranslation("help-articles");

  return (
    <button
      type="button"
      onClick={() => openHelp(scope, articleId)}
      className="p-2 rounded-md hover:bg-primary-container/40 transition text-muted-foreground hover:text-foreground"
      title={t("panel.trigger")}
      aria-label={t("panel.trigger")}
    >
      <HelpCircle size={18} />
    </button>
  );
}
